import React from "react";
import PrismaZoom from "react-prismazoom";
import "./Trawka.scss";

import Road from "../Road/Road";


const isDevelopment = () => process.env.NODE_ENV !== 'production';

function Trawka() {
  return (
    <>
      
      
      {/* <PrismaZoom> */}
          <Road />
          {/* </PrismaZoom> */}
 
      
     
 
    
    </>
  );
}

export default Trawka;
